import TrustPilot from './TrustPilot'

export default TrustPilot
// eslint-disable-next-line import/export
export * from './TrustPilot'
